import { render, staticRenderFns } from "./leifeng_health_suggestion.vue?vue&type=template&id=6efc1451&scoped=true&"
import script from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
export * from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
import style0 from "./leifeng_health_suggestion.vue?vue&type=style&index=0&id=6efc1451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc1451",
  null
  
)

export default component.exports